/** Compact inline table cell padding for modals and note metadata. */
export const COMPACT_TABLE_STYLES = {
  th: { padding: '0.375rem 0.5rem' },
  td: { padding: '0.375rem 0.5rem' },
} as const;

/** Bordered card tables (appointment header, modals). */
export const CARD_TABLE_STYLES = {
  thead: {
    backgroundColor: 'var(--mantine-color-gray-1)',
  },
  th: {
    padding: '0.625rem 0.75rem',
    fontWeight: 500,
    fontSize: 'var(--mantine-font-size-xs)',
    letterSpacing: 'normal',
    textTransform: 'none',
    color: 'var(--mantine-color-gray-6)',
    backgroundColor: 'var(--mantine-color-gray-1)',
    borderBottom: '1px solid var(--mantine-color-gray-3)',
  },
  td: {
    padding: '0.625rem 0.75rem',
    fontSize: 'var(--mantine-font-size-sm)',
    letterSpacing: 'normal',
    backgroundColor: 'var(--mantine-color-white)',
    borderBottom: 'none',
  },
  tr: {
    backgroundColor: 'var(--mantine-color-white)',
  },
} as const;

/** Matches theme Input/Select border (#9CA3AF) used across the design system. */
export const CARD_TABLE_PAPER_PROPS = {
  withBorder: true,
  radius: 'md' as const,
  bg: 'white' as const,
  style: {
    overflow: 'hidden' as const,
    borderColor: '#9CA3AF',
  },
};
